import { Link } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import { blogs, blogCategories } from "../../data/blog";

export default function BlogSidebar() {
  const tags = [...new Set(blogs.flatMap((b) => b.tags))];
  return (
    <aside>
      <div className="sidebar-box">
        <h3>Search</h3>
        <form onSubmit={(e) => e.preventDefault()} style={{ display: "flex" }}>
          <input className="input" placeholder="Search..." style={{ borderRadius: "10px 0 0 10px" }} />
          <button className="btn btn-primary" style={{ borderRadius: "0 10px 10px 0", padding: "0 18px" }}>
            <FaSearch />
          </button>
        </form>
      </div>

      <div className="sidebar-box">
        <h3>Categories</h3>
        <ul className="sidebar-links">
          {blogCategories.map((c) => (
            <li key={c}>
              <Link to="/blog-grid">{c} <span>{blogs.filter((b) => b.category === c).length}</span></Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="sidebar-box">
        <h3>Recent Posts</h3>
        {blogs.slice(0, 3).map((b) => (
          <Link to={`/blogs/${b.id}`} key={b.id} className="cart-prod" style={{ marginBottom: 16 }}>
            <img src={b.image} alt={b.title} />
            <div>
              <p style={{ color: "#fff", fontSize: 14, lineHeight: 1.3 }}>{b.title.slice(0, 42)}...</p>
              <span style={{ color: "var(--yellow)", fontSize: 12 }}>{b.date}</span>
            </div>
          </Link>
        ))}
      </div>

      <div className="sidebar-box">
        <h3>Tags</h3>
        <div className="tag-list">
          {tags.map((t) => <Link to="/blog-grid" key={t}>#{t}</Link>)}
        </div>
      </div>
    </aside>
  );
}
